module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-22-min.2927fa0a.jpg";